import React from 'react';
import PropTypes from 'prop-types';
import FusionCharts from 'fusioncharts';
import charts from 'fusioncharts/fusioncharts.charts';
import ReactFusioncharts from 'react-fusioncharts';
import {
  performanceToColor,
  calculateDisplayValueFormatting,
  calculateHomeBarChartAxis
} from 'utils/widget-helpers';

charts(FusionCharts);

const HeatmapBarChart = ({ data, sortType }) => {
  const chartHeight = data.length > 0 && data.length * 35 + 200;

  const dataSource = {
    chart: {
      yaxisname: calculateHomeBarChartAxis(sortType),
      plottooltext: '<b>$dataValue</b>',
      theme: 'fusion',
      showvalues: '1',
      showanchors: '1',
      numbersuffix: sortType === 'value' && '%'
    },
    data: [
      ...data.map(item => ({
        label: `${item.name}`,
        value: calculateDisplayValueFormatting(sortType, item[sortType]),
        color: performanceToColor(item.value).backgroundColor
      }))
    ]
  };
  return (
    <>
      {data && chartHeight && (
        <ReactFusioncharts
          type="bar2d"
          width="100%"
          height={chartHeight}
          dataFormat="JSON"
          dataSource={dataSource}
        />
      )}
    </>
  );
};

HeatmapBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sortType: PropTypes.string.isRequired
};

export default HeatmapBarChart;
